<template>
    <div>
      <v-tooltip
        top
        :disabled="module.name.length <= 30">
        <template
          v-slot:activator="{ on }">
          <v-subheader
            v-on="on"
            class="playlist-moduleTOC-body-2 mt-4 mod-subheader"
            :class="[{ 'text-truncate': module.name.length > 30}, module.name]"
            :style="{color: playlist.default_color, width: '240px', display: 'inline-block'}">
            {{ module.name }}
          </v-subheader>
        </template>
        <span>{{ module.name }}</span>
      </v-tooltip>
      <template v-for="moduleItem in module.moduleItems">
        <BulbTOC v-if="moduleItem.type === 'bulb'" :key="moduleItem.id" :moduleBulb="moduleItem" :moduleId="moduleId"></BulbTOC>
        <TextTOC v-else-if="moduleItem.type === 'text'" :key="moduleItem.id" :textElement="moduleItem" :moduleId="moduleId"></TextTOC>
        <ResourceTOC v-else :key="moduleItem.id" :resource="moduleItem" :moduleId="moduleId"></ResourceTOC>
      </template>
    </div>
</template>

<script>
import {
  mapState,
} from 'vuex';
import BulbTOC from './BulbTOC.vue';
import ResourceTOC from './ResourceTOC.vue';
import TextTOC from './TextTOC.vue';

export default {
  components: {
    BulbTOC,
    ResourceTOC,
    TextTOC,
  },
  props: ['module', 'moduleId'],
  computed: {
    ...mapState([
      'playlist',
    ]),
  },
};
</script>

<style lang="scss">
  .playlist-moduleTOC-body-2 {
    font-size: .875rem !important;
    letter-spacing: .0178571429em !important;
    line-height: 1.25rem;
  }
</style>
